import {inject, Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {PaymentPollingStatus, PaymentVerificationResult} from '@features/payment/domain/model/payment.model';
import {PaymentStrategy} from '@features/payment/domain/ports/strategy/payment-strategy.port';
import {Payment} from '@features/payment/domain/entities/payment.entity';
import {WalletsGateway} from '@features/payment/infrastructure/gateways/wallets.gateway';
import {CheckoutPayloadMapper} from '@features/payment/infrastructure/mappers/checkout-payload.mapper';

@Injectable({providedIn: 'root'})
export class WalletSettlementStrategy implements PaymentStrategy {
  private readonly walletsGateway = inject(WalletsGateway);
  private readonly payloadMapper = inject(CheckoutPayloadMapper);

  checkout(payments: Payment[]): Observable<string> {
    const payload = this.payloadMapper.toCheckoutPayload(payments);

    return this.walletsGateway.checkout(payload);
  }

  verify(): Observable<PaymentVerificationResult> {
    return of({status: PaymentPollingStatus.COMPLETED});
  }
}
